var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2117_4177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3627 13.7109C11.6158 13.4578 12.0518 13.4578 12.3049 13.7109L15.9143 17.3203C16.5799 17.9859 17.4658 18.3515 18.4033 18.3515H19.1112L14.5596 22.9031C13.1393 24.2859 10.833 24.2859 9.41272 22.9031L4.84241 18.3375H5.27835C6.21585 18.3375 7.10178 17.9719 7.76741 17.3062L11.3627 13.7109ZM12.3049 10.2609C12.0049 10.5187 11.6205 10.5234 11.3627 10.2609L7.76741 6.6656C7.10178 5.95779 6.21585 5.63435 5.27835 5.63435H4.84241L9.40803 1.06685C10.833 -0.355617 13.1393 -0.355617 14.5596 1.06685L19.1158 5.62029H18.4033C17.4658 5.62029 16.5799 5.98591 15.9143 6.65154L12.3049 10.2609ZM5.27835 6.68904C5.92522 6.68904 6.52053 6.95154 7.01741 7.41091L10.6127 11.0062C10.9502 11.3015 11.3908 11.5125 11.8362 11.5125C12.2768 11.5125 12.7174 11.3015 13.0549 11.0062L16.6643 7.39685C17.1237 6.94216 17.7565 6.67966 18.4033 6.67966H20.1705L22.9033 9.41248C24.3237 10.8328 24.3237 13.139 22.9033 14.5594L20.1705 17.2922H18.4033C17.7565 17.2922 17.1237 17.0297 16.6643 16.5703L13.0549 12.9609C12.4033 12.3094 11.2643 12.3094 10.6127 12.9656L7.01741 16.5562C6.52053 17.0156 5.92522 17.2781 5.27835 17.2781H3.78678L1.0671 14.5594C-0.355373 13.139 -0.355373 10.8328 1.0671 9.41248L3.78678 6.68904H5.27835Z",
    fill: "#C51F2A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2117_4177"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPix);
export default __webpack_public_path__ + "static/media/iconPix.c5cf66ce7ff57ac95bbd98c74d73f1b8.svg";
export { ForwardRef as ReactComponent };